const ImageLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) => {
  return `${src}?imageView2/2/w/${width}/q/${quality || 75}`;
};
export default ImageLoader;
